/** The draw cursor's numbers, shared by DrawCursor and its stylesheet. */

/** Dot diameter at rest, in px. */
export const DOT_SIZE = 10;

/** How far the dot shrinks while inking: 10px → 4px. */
export const DOT_SCALE = 0.4;

/** How long the shrink runs, each way. */
export const MORPH_MS = 140;

/** tldraw's light-theme blue, used when a region carries no colour. */
export const DEFAULT_INK = "#4465e9";
